import * as React from "react";
import { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Alert from "@mui/material/Alert";
import { monFetch } from "../inc/inc";
import Testo from "../elementi/Testo";
import { useLocation } from "react-router-dom";

export default function Comp(props) {
  const [errore, setErrore] = useState(false);
  const [erroreMsg, setErroreMsg] = useState(false);
  const [successo, setSuccesso] = useState(false);
  const [successoMsg, setSuccessoMsg] = useState(false);
  const [campiErrore, setCampiErrore] = useState([]);


  const [ragioneSociale, setRagioneSociale] = useState("");
  const [citta, setCitta] = useState("");
  const [provincia, setProvincia] = useState("");
  const [piva, setPiva] = useState("");
  const [cf, setCf] = useState("");

  const [sourcePage, setSourcePage] = useState("");
  const [nomeTecnico, setNomeTecnico] = useState("");
  const [telefonoTecnico, setTelefonoTecnico] = useState("");
  const [cellulareTecnico, setCellulareTecnico] = useState("");
  const [emailTecnico, setEmailTecnico] = useState("");

  async function logon(e) {
    e.preventDefault();
    const res = await monFetch("/customerLogon", {
      businessName: ragioneSociale,
      city: citta,
      state: provincia,
      piva: piva,
      cf: cf,
      technicalName: nomeTecnico,
      technicalPhone: telefonoTecnico,
      technicalMobile: cellulareTecnico,
      technicalEmail: emailTecnico,
      rel: sourcePage
    });
    if (res.success) {
      // registrazione effettuata, proporre un messaggio per il successo della registrazione ed eventualmente un redirect
      setSuccesso(true);
      setSuccessoMsg('Registrazione effettuata correttamente');
      setTimeout((sourcePage) => {
        window.location.href = sourcePage;
      }, 5000);
    } else {
      setErroreMsg(res.msg);
      setErrore(true);
      if (res.fields) {
        setCampiErrore(res.fields);
      }
    }
  }

  let location = useLocation();
  useEffect(() => {
    // read the rel GET param
    let rel = new URLSearchParams(location.search).get("rel");
    console.log(rel);
    setSourcePage(rel);
  }, []);

  return (
    <div className="flexContCenter">
      <div style={{ maxWidth: "800px", textAlign: 'center' }}>
        <img alt="Questionario PSS Sinattica" src={process.env.PUBLIC_URL + "/img/logo.png"} style={{ maxWidth: "350px" }} />

        <form onSubmit={(e) => logon(e)}>
          <input type="hidden" name="source" value={sourcePage} />
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h2 style={{ marginTop: 0 }}>IT Risk Assessment</h2>
              <h4>Registrati e lasciaci i dati del tuo studio per essere ricontattato il prima possibile da uno dei nostri commerciali</h4>
              {errore && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {erroreMsg}
                </Alert>
              )}
              {successo && (
                <Alert severity="success" sx={{ mb: 2 }}>
                  {successoMsg}
                </Alert>
              )}
            </Grid>
            <Grid item sm={6} xs={12}>
              <Testo
                required
                error={campiErrore.includes('businessName')}
                label="Ragione sociale"
                type="text"
                id="businessName"
                value={ragioneSociale}
                onChange={(e) => setRagioneSociale(e.target.value)}
              />
            </Grid>
            <Grid item sm={4} xs={12}>
              <Testo
                error={campiErrore.includes('city')}
                required
                label="Città"
                id="city"
                value={citta || ""}
                onChange={(e) => {
                  setCitta(e.target.value);
                }}
              />
            </Grid>
            <Grid item sm={2} xs={12}>
              <Testo
                error={campiErrore.includes('state')}
                required
                label="Provincia"
                id="state"
                value={provincia || ""}
                onChange={(e) => {
                  setProvincia(e.target.value);
                }}
                inputProps={{
                  maxLength: 2,
                }}
              />
            </Grid>

            <Grid item sm={6} xs={12}>
              <Testo
                error={campiErrore.includes('piva')}
                required
                label="Partita IVA"
                id="piva"
                value={piva || ""}
                onChange={(e) => {
                  setPiva(e.target.value);
                }}
                inputProps={{
                  minLength: 11
                }}
              />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Testo
                error={campiErrore.includes('cf')}
                required
                label="C.F."
                id="cf"
                value={cf || ""}
                onChange={(e) => {
                  setCf(e.target.value);
                }}
                inputProps={{
                  maxLength: 16,
                }}
              />
            </Grid>
            <Grid container item sm={12} xs={12} spacing={2} style={{ marginTop: '0.6em' }}>
              <Grid item sm={6} xs={12}>
                <Testo
                  error={campiErrore.includes('technicalName')}
                  required
                  label="Referente Tecnico (nome e cognome)"
                  id="technicalName"
                  value={nomeTecnico || ""}
                  onChange={(e) => {
                    setNomeTecnico(e.target.value);
                  }}
                  inputProps={{}}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Testo
                  error={campiErrore.includes('technicalEmail')}
                  required
                  label="Email referente tecnico"
                  id="technicalEmail"
                  value={emailTecnico || ""}
                  onChange={(e) => {
                    setEmailTecnico(e.target.value);
                  }}
                  inputProps={{}}
                />
              </Grid>
              <Grid item sm={6} xs={12}>
                <Testo
                  error={campiErrore.includes('technicalPhone')}
                  label="Telefono referente tecnico"
                  id="technicalPhone"
                  value={telefonoTecnico || ""}
                  onChange={(e) => {
                    setTelefonoTecnico(e.target.value);
                  }}
                  inputProps={{}}
                />
              </Grid>

              <Grid item sm={6} xs={12}>
                <Testo
                  error={campiErrore.includes('technicalMobile')}
                  label="Cellulare referente tecnico"
                  id="technicalMobile"
                  value={cellulareTecnico || ""}
                  onChange={(e) => {
                    setCellulareTecnico(e.target.value);
                  }}
                  inputProps={{}}
                />
              </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '0.6em' }}>
              <Button variant="contained" color="error" style={{ backgroundColor: '#E02B20' }} fullWidth type="submit">
                Invia richiesta
              </Button>
            </Grid>
          </Grid>
        </form>
      </div>
    </div>
  );
}
